export default "__VITE_ASSET__CqJf91Tp__"